(function() { window.GUID_011a15e9_794c_4b53_bd67_6f49edd0ba83 = { getGuid: function() { return "011a15e9-794c-4b53-bd67-6f49edd0ba83"; } }; })();
let offOnList = new Array();
function validateEvent(eventName, selector) {
    if (eventName.indexOf(".") == -1) {
        //throw 'A namespace for event ' + eventName + ' is missing!!!!';
        console.error('A namespace for event ' + eventName + ' is missing. A random namespace will be generated.');
        eventName += `.${CS.Helper.generateRandomId()}`;
    }
    //let eventMonitoringElement: IEventMonitoring = {
    //    eventName: eventName,
    //    selector: selector
    //};
    //for (var i = 0; i < offOnList.length; i++) {
    //    let current = offOnList[i];
    //    if (current.eventName == eventMonitoringElement.eventName &&
    //        current.selector == eventMonitoringElement.selector) {
    //        throw 'Event ' + eventName + ' is already in use!!!';
    //    }
    //}
    //offOnList.push(eventMonitoringElement);
}
jQuery.fn.extend({
    offonwithoutautooff: function (events, selector, handler) {
        let splitBySpace = events.split(' ');
        $.each(splitBySpace, function (i, element) {
            validateEvent(element, selector);
        });
        this.off(events).on(events, selector, handler);
        return this;
    },
    offon: function (events, selector, handler) {
        let splitBySpace = events.split(' ');
        $.each(splitBySpace, function (i, element) {
            validateEvent(element, selector);
        });
        this.off(events).on(events, selector, handler);
        return this;
    },
    disableSelection: function () {
        return this
            .attr('unselectable', 'on')
            .css('user-select', 'none')
            .on('selectstart', false);
    },
    scrollTo: function (scrollOffset, duration) {
        let $target = $(this);
        if ($target != null && $target.length > 0) {
            if (duration == null) {
                duration = 400;
            }
            let offset = 0;
            if (scrollOffset != null) {
                offset = scrollOffset;
            }
            $('html, body').animate({ scrollTop: $target.offset().top + offset }, duration);
        }
    }
});
(function ($) {
    let originalVal = $.fn.val;
    $.fn.val = function (value) {
        if (this[0]) {
            let ele = $(this[0]);
            if (ele.hasClass("checkbox") && ele.hasClass("control-cs") && !ele.hasClass("isreadonly")) {
                let checkbox = CS.Controls.GetInstance(CS.Controls.CheckBox, ele);
                if (arguments.length >= 1) {
                    if (checkbox)
                        checkbox.SetValue(value);
                }
                else {
                    if (checkbox)
                        return checkbox.GetValue();
                    else
                        return null;
                }
            }
            else {
                return originalVal.apply(this, arguments);
            }
        }
    };
})(jQuery);

//# sourceMappingURL=jquery.extensions.js.map
